// import {
//   Box,
//   Button,
//   Input,
//   VStack,
//   Heading
// } from "@chakra-ui/react";

// import { useState } from "react";
// import { useNavigate } from "react-router-dom";

// import { AuthService }
//   from "../../services/auth.service";

// export default function LoginPage() {

//   const navigate =
//     useNavigate();

//   const [email, setEmail] =
//     useState("");

//   const [password, setPassword] =
//     useState("");

//   async function handleLogin() {

//     try {

//       const response =
//         await AuthService.login(
//           email,
//           password
//         );

//       localStorage.setItem(
//         "token",
//         response.data.token
//       );

//       navigate("/");

//     } catch {

//       alert(
//         "Usuário ou senha inválidos"
//       );
//     }
//   }

//   return (

//     <Box
//       maxW="400px"
//       mx="auto"
//       mt={20}
//     >

//       <VStack spacing={4}>

//         <Heading size="md">
//           Login
//         </Heading>

//         <Input
//           placeholder="Email"
//           value={email}
//           onChange={(e) =>
//             setEmail(
//               e.target.value
//             )
//           }
//         />

//         <Input
//           type="password"
//           placeholder="Senha"
//           value={password}
//           onChange={(e) =>
//             setPassword(
//               e.target.value
//             )
//           }
//         />

//         <Button
//           colorScheme="blue"
//           w="100%"
//           onClick={handleLogin}
//         >
//           Entrar
//         </Button>

//       </VStack>

//     </Box>
//   );
// }
import {
  Box,
  Button,
  Input,
  VStack,
  Heading,
  Flex,
  Text,
  Icon,
  Image
} from "@chakra-ui/react";

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthService } from "../../services/auth.service";

import { FiLock, FiShield } from "react-icons/fi";

export default function LoginPage() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  async function handleLogin() {
    try {
      const response = await AuthService.login(email, password);

      localStorage.setItem("token", response.data.token);

      navigate("/");
    } catch {
      alert("Usuário ou senha inválidos");
    }
  }

  return (
    <Flex minH="100vh">

      {/* ESQUERDA - FORM */}
      <Box
        flex="1"
        display="flex"
        alignItems="center"
        justifyContent="center"
        bg="white"
        p={8}
      >
        <Box w="100%" maxW="360px">
          <VStack spacing={4} align="stretch">

            <Icon as={FiLock} boxSize={8} color="blue.500" />

            <Heading size="md">Login</Heading>

            <Input
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <Input
              type="password"
              placeholder="Senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <Button
              colorScheme="blue"
              w="100%"
              onClick={handleLogin}
            >
              Entrar
            </Button>

          </VStack>
        </Box>
      </Box>

      {/* DIREITA - BRANDING */}
      <Box
        flex="1"
        bgGradient="linear(to-br, blue.600, blue.900)"
        color="white"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        position="relative"
        overflow="hidden"
      >
        {/* ícone decorativo topo */}
        <Icon
          as={FiShield}
          boxSize={16}
          opacity={0.2}
          position="absolute"
          top="10%"
        />

        {/* LOGO */}
        <Image
          src="/logo.png"
          boxSize="120px"
          mb={4}
        />

        <Heading size="lg" mb={2}>
          Sistema de Fichas
        </Heading>

        <Text opacity={0.8}>
          Gestão inteligente e rápida
        </Text>
      </Box>

    </Flex>
  );
}